import React, { Component } from "react";
import InfoDialogTitleViewStyle from "./InfoDialogTitleViewStyle";

export default class InfoDialogTitleView extends Component {
    
    private _style = new InfoDialogTitleViewStyle();

    render() {
        return (
            <span style={this._style.title}>
                {this.props.children}
            </span>
        );
    }
}